export default __webpack_public_path__ + "static/media/product-image-11.624f65e1.jpg";